import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals'

const reportWebVitals = (onPerfEntry?: () => void) => {
    if (onPerfEntry && typeof onPerfEntry === 'function') {
        onCLS(onPerfEntry)
        onFCP(onPerfEntry)
        onLCP(onPerfEntry)
        onTTFB(onPerfEntry)
        onINP(onPerfEntry) // Replacing onFID with onINP
    }
}

export default reportWebVitals
